/* 7ate9 linen pages: shared behaviour for every linen section.
   - Modals (drawers, sheets): Linen.openModal(el, opener), Linen.closeModal(el),
     [data-linen-open="<modal id>"] opens, [data-linen-close] closes, Esc closes, focus is trapped.
   - Accordions: [data-linen-acc-toggle] inside .linen-acc; [data-linen-acc-single] keeps one open.
     Linen.openAccordion('<item id>') opens one from code (e.g. the size guide link).
   - Money: Linen.formatMoney(cents) in the shop's format, without trailing .00 like the
     money_without_trailing_zeros filter.
   Events (on document): linen:modal:open / linen:modal:close (detail.modal). */
(function () {
  var Linen = (window.Linen = window.Linen || {});
  var FOCUSABLE =
    'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  var stack = [];

  function panelOf(modal) {
    return modal.querySelector('[data-linen-panel]') || modal;
  }

  function visibleFocusables(modal) {
    return Array.prototype.filter.call(panelOf(modal).querySelectorAll(FOCUSABLE), function (el) {
      return el.offsetParent !== null || el === document.activeElement;
    });
  }

  Linen.openModal = function (modal, opener) {
    if (!modal || modal.classList.contains('is-open')) return;
    modal.__opener = opener || document.activeElement;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    stack.push(modal);
    document.body.classList.add('linen-lock');
    var target = panelOf(modal).querySelector('[data-linen-autofocus]') || panelOf(modal);
    setTimeout(function () {
      target.focus({ preventScroll: true });
    }, 30);
    document.dispatchEvent(new CustomEvent('linen:modal:open', { detail: { modal: modal } }));
  };

  Linen.closeModal = function (modal) {
    if (!modal || !modal.classList.contains('is-open')) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    var i = stack.indexOf(modal);
    if (i > -1) stack.splice(i, 1);
    if (!stack.length) document.body.classList.remove('linen-lock');
    var opener = modal.__opener;
    modal.__opener = null;
    if (opener && opener.focus && document.contains(opener)) {
      opener.focus({ preventScroll: true });
    } else if (stack.length) {
      panelOf(stack[stack.length - 1]).focus({ preventScroll: true });
    }
    document.dispatchEvent(new CustomEvent('linen:modal:close', { detail: { modal: modal } }));
  };

  Linen.topModal = function () {
    return stack[stack.length - 1] || null;
  };

  function toggleAccordion(btn, force) {
    var item = btn.closest('.linen-acc');
    if (!item) return;
    var open = typeof force === 'boolean' ? force : btn.getAttribute('aria-expanded') !== 'true';
    var group = btn.closest('[data-linen-acc-single]');
    if (open && group) {
      group.querySelectorAll('.linen-acc.is-open [data-linen-acc-toggle]').forEach(function (other) {
        if (other !== btn) toggleAccordion(other, false);
      });
    }
    btn.setAttribute('aria-expanded', String(open));
    item.classList.toggle('is-open', open);
  }

  Linen.openAccordion = function (id) {
    var item = document.getElementById(id);
    var btn = item && item.querySelector('[data-linen-acc-toggle]');
    if (btn) toggleAccordion(btn, true);
    return item;
  };

  document.addEventListener('click', function (e) {
    var closer = e.target.closest('[data-linen-close]');
    if (closer) {
      e.preventDefault();
      Linen.closeModal(closer.closest('.linen-modal'));
      return;
    }
    var opener = e.target.closest('[data-linen-open]');
    if (opener) {
      e.preventDefault();
      Linen.openModal(document.getElementById(opener.getAttribute('data-linen-open')), opener);
      return;
    }
    var acc = e.target.closest('[data-linen-acc-toggle]');
    if (acc) toggleAccordion(acc);
  });

  document.addEventListener('keydown', function (e) {
    var modal = Linen.topModal();
    if (!modal) return;
    if (e.key === 'Escape') {
      Linen.closeModal(modal);
      return;
    }
    if (e.key !== 'Tab') return;
    var items = visibleFocusables(modal);
    if (!items.length) {
      e.preventDefault();
      return;
    }
    var first = items[0];
    var last = items[items.length - 1];
    if (!panelOf(modal).contains(document.activeElement)) {
      e.preventDefault();
      first.focus();
    } else if (e.shiftKey && (document.activeElement === first || document.activeElement === panelOf(modal))) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });

  function delimit(number, precision, thousands, decimal) {
    var parts = number.toFixed(precision).split('.');
    var whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
    return parts[1] ? whole + decimal + parts[1] : whole;
  }

  // Theme editor: a section reloaded while its modal was open must not leave the page locked.
  document.addEventListener('shopify:section:unload', function (e) {
    stack.slice().forEach(function (modal) {
      if (e.target.contains(modal)) Linen.closeModal(modal);
    });
  });

  Linen.formatMoney = function (cents, format) {
    var value = (Number(cents) || 0) / 100;
    var fmt = format || Linen.moneyFormat || '₹{{amount}}';
    var out = fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals':
          return delimit(value, 0, ',', '.');
        case 'amount_with_comma_separator':
          return delimit(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator':
          return delimit(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator':
          return delimit(value, 2, "'", '.');
        default:
          return delimit(value, 2, ',', '.');
      }
    });
    return out.replace(/[.,]00(?!\d)/, '');
  };
})();
